import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';

import { AuthService } from '../../../auth/auth.service';
import { ContextService } from '../../../context.service';
import { ErrorPage } from '../error-page';
import { Button } from '../../../../shared/components/button/button';

/** Landing for an authenticated account that belongs to no organization —
 *  nothing the user can fix in-app, so the only action is signing out. */
@Component({
  selector: 'app-no-organization',
  imports: [TranslocoDirective, ErrorPage, Button],
  template: `
    <ng-container *transloco="let t; read: 'errors.noOrganization'">
      <app-error-page
        [eyebrow]="t('eyebrow')"
        [title]="t('title')"
        [body]="t('body')"
        [rows]="[
          { label: t('rows.signedInAs'), value: email() },
          { label: t('rows.organizations'), value: organizationCount() },
        ]"
      >
        <app-button [label]="t('signOut')" (activated)="onSignOut()" />
      </app-error-page>
    </ng-container>
  `,
})
export class NoOrganizationPage {
  private readonly authService = inject(AuthService);
  private readonly contextService = inject(ContextService);

  private readonly user = toSignal(this.contextService.user$, { initialValue: null });
  private readonly organizations = toSignal(this.contextService.organizations$, {
    initialValue: [],
  });

  protected readonly email = computed(() => this.user()?.email ?? '');
  protected readonly organizationCount = computed(() => String(this.organizations().length));

  onSignOut(): void {
    this.authService.logout();
  }
}
